import React, { useEffect, useState, useContext } from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxProduct from "../../util/remote/ajaxProduct";
import { Link } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import TableHeader from "../../Components/Common/TableHeader";
import jsPDF from "jspdf";
import Select from "react-select";
import "jspdf-autotable";
import useStateCallback from "../../util/customHooks/useStateCallback";
import UpdateDelveryNote from "./UpdateDelveryNote";
import toast, { Toaster } from "react-hot-toast";
import ClientContext from "../../Context/ClientContext";
import ajaxStores from "../../util/remote/ajaxStores";
function ListDeliveryNotes() {
  const [deliveryNotes, setDeliveryNotes] = useState(false);
  const [loading, setLoading] = useState(false);
  const { clientList } = useContext(ClientContext);
  const [start_date, setStart_date] = useState("");
  const [to_date, setTo_date] = useState("");
  const [store_id, setStore_id] = useState("");
  const [client, setClient] = useState("");
  useEffect(() => {
    getDeliveryNotes();
  }, [store_id, client, to_date, start_date]);
  const getDeliveryNotes = async () => {
    let data = {
      client: client,
      storeID: store_id,
      to_date: to_date,
      start_date: start_date,
    };
    setLoading(true);
    const server_response = await ajaxProduct.fetchDeliveryNotes(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setDeliveryNotes(server_response.details);
    }
  };
  const exportToPDF = () => {
    const table = document.querySelector(".table"); // Select the table element
    const pdf = new jsPDF("p", "pt", "a4");
    const companyName = "BERICOT AFRICA LIMITED ";
    const companyAddress = "KAMPALA UGANDA \n TEL:+256701666160";
    const currentDate = `Date of Printing: ${new Date().toLocaleDateString()}`;
    const headerDescription = "delivery notes  Report"; // The line to show what the PDF is about
    // Get the PDF page width for centering the text
    const pageWidth = pdf.internal.pageSize.getWidth();
    // Add company name (equivalent to <h1>)
    pdf.setFontSize(14); // Font size for <h1>
    const companyNameWidth = pdf.getTextWidth(companyName);
    pdf.text(companyName, (pageWidth - companyNameWidth) / 2, 50); // Centered <h1>
    // Add company address (equivalent to <h2>)
    pdf.setFontSize(12); // Font size for <h2>
    const companyAddressWidth = pdf.getTextWidth(companyAddress.split("\n")[0]);
    pdf.text(
      companyAddress.split("\n")[0],
      (pageWidth - companyAddressWidth) / 2,
      80
    ); // Centered <h2>
    const companyAddressCityWidth = pdf.getTextWidth(
      companyAddress.split("\n")[1]
    );
    pdf.text(
      companyAddress.split("\n")[1],
      (pageWidth - companyAddressCityWidth) / 2,
      100
    ); // Centered <h3>
    // Add printing date (equivalent to <h3>)
    pdf.setFontSize(9); // Font size for <h3>
    const dateWidth = pdf.getTextWidth(currentDate);
    pdf.text(currentDate, (pageWidth - dateWidth) / 2, 130); // Centered <h3>
    // Add header description (equivalent to a line explaining the document)
    pdf.setFontSize(12); // Font size for description
    const headerDescriptionWidth = pdf.getTextWidth(headerDescription);
    pdf.text(headerDescription, (pageWidth - headerDescriptionWidth) / 2, 160); // Centered description  const table = document.querySelector(".table"); // Select the table element
    // Define columns for the table (add more if needed)
    const columns = ["Date", "Reference No.", "Client Name", "Received By"];
    // Extract data from the table and format it as an array of arrays
    const data = Array.from(table.querySelectorAll("tr")).map((row) => {
      return Array.from(row.querySelectorAll("td")).map(
        (cell) => cell.textContent
      );
    });
    // Remove the header row
    // data.shift();
    // Create the PDF document and add the table
    pdf.autoTable({
      startY: 180,
      head: [columns],
      body: data,
    });
    // Save the PDF
    pdf.save(`delivery_data_${new Date().toLocaleDateString()}.pdf`);
  };
  // modal for updating delivery note
  const [UpdateNote, setUpdateNote] = useStateCallback(false);
  const handleNoteUpdating = (e, item) => {
    e.preventDefault();
    setUpdateNote(false, () =>
      setUpdateNote(
        <UpdateDelveryNote data={item} function={getDeliveryNotes} />
      )
    );
  };
  // hadles delievery note deletion
  const handleDeleteDeliveryNote = async (e, ID) => {
    e.preventDefault();
    const isConfirmed = window.confirm(
      "Are you sure you want to delete the Note and the related Inventory ?"
    );
    if (isConfirmed) {
      var dataa = {
        noteID: ID,
      };
      const server_response = await ajaxProduct.DeleteDeliveryNote(dataa);
      if (server_response.status === "OK") {
        getDeliveryNotes();
        toast.success(server_response.message);
      } else {
        toast.error(server_response.message);
      }
    }
  };
  // --------------------------------
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setTo_date(today);
  }, []);
  const resetFilter = (e) => {
    e.preventDefault();
    setStore_id("");
    setClient("");
    setStart_date("");
  };
  const [store, setStores] = useState(false);
  const get_stores = async () => {
    const server_response = await ajaxStores.fetchStores();
    if (server_response.status === "OK") {
      setStores(server_response.details);
    }
  };
  useEffect(() => {
    get_stores();
  }, []);
  return (
    <AppContainer title="Delivery Notes">
      {UpdateNote}
      <div
        className="row clearfix"
        style={{ marginRight: "-5px", marginLeft: "-5px" }}
      >
        <div
          className="col-lg-12 col-md-12 col-sm-12"
          style={{ paddingRight: "5px", paddingLeft: "5px" }}
        >
          <div className="card mb-1" style={{ borderRadius: ".55rem" }}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 col-xl-12 mb-0">
                  <div className="row">
                    <div className="col-md-2">
                      <b>Select Client:</b>
                      <br />
                      <Select
                        onChange={(e) => setClient(e.client_id)}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.client_id}
                        isSearchable
                        options={Array.isArray(clientList) ? clientList : []}
                        value={
                          client
                            ? Array.isArray(clientList) &&
                              clientList.find(
                                (value) => value.client_id === client
                              )
                            : ""
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <b>Select store:</b>
                      <br />
                      <Select
                        onChange={(e) => setStore_id(e.id)}
                        getOptionLabel={(option) => option.storeName}
                        getOptionValue={(option) => option.id}
                        isSearchable
                        options={Array.isArray(store) ? store : []}
                        value={
                          store_id
                            ? Array.isArray(store) &&
                              store.find((value) => value.id === store_id)
                            : ""
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <b>From:</b>
                      <input
                        type="date"
                        value={start_date}
                        onChange={(e) => setStart_date(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <b>To:</b>
                      <input
                        type="date"
                        value={to_date}
                        onChange={(e) => setTo_date(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-xl-2 mt-4">
                      <div className="input-group-append">
                        <button
                          onClick={(e) => resetFilter(e)}
                          style={{
                            borderRadius: "10px ",
                          }}
                          className="btn btn-primary  color-white"
                        >
                          Reset Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card custom-card">
        <div className="card-body">
          {loading && <Loader />}
          <Toaster />

          <TableHeader
            title="Delivery Notes"
            subtitle="List of all the delivery notes"
            viewButton={
              <>
                <a
                  href="#"
                  onClick={exportToPDF}
                  className="btn btn-secondary btn-sm mr-2"
                  style={{ float: "right", borderRadius: "5px" }}
                >
                  Export to PDF
                </a>
                <Link
                  style={{ float: "right", borderRadius: "5px" }}
                  className="btn btn-success mb-4 mr-2 btn-sm"
                  to="/inventory/create"
                >
                  Add Delivery Note
                </Link>
              </>
            }
          />
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-responsive">
              <thead>
                <th>Date</th>
                <th>Reference No.</th>
                <th>Client Name</th>
                <th>Received By</th>
                <th style={{ width: "100px" }}>Comment By</th>
                <th>Delivered By</th>
                <th>vehicle_plate</th>
                <th>Store Name</th>
                <th>Store location</th>
                <th>Delivery DateTime</th>
                <th>
                  View <br /> items
                </th>
                <th>Actions</th>
              </thead>
              <tbody>
                {!Array.isArray(deliveryNotes) && <tr>No results found</tr>}
                {Array.isArray(deliveryNotes) &&
                  deliveryNotes.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date_added.short_date}</td>
                      <td>{item.delivery_note}</td>
                      <td>{item.client_name}</td>
                      <td>{item.received_by}</td>
                      <td style={{ width: "1   By00px", wordWrap: "normal" }}>
                        {item.comment}
                      </td>
                      <td>{item.delivered_by}</td>
                      <td>{item.vehicle_plate}</td>
                      <td>{item.store_name}</td>
                      <td>{item.location}</td>
                      <td>
                        {item.date_added.short_date}/{item.time}
                      </td>
                      <td>
                        <div
                          className=""
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            padding: "5px",
                          }}
                        >
                          <Link
                            className="btn btn-sm btn-primary mr-2"
                            to={`products/list/${item.ID}`}
                            style={{
                              borderRadius: "5px",
                              margin: "5px",
                            }}
                          >
                            <i class="fa-regular fa-eye"></i>
                            Products
                          </Link>
                          <Link
                            className="btn btn-sm btn-success mr-2"
                            to={`input/add/${item.ID}`}
                            style={{
                              borderRadius: "5px",
                              margin: "5px",
                            }}
                          >
                            <i class="fa fa-plus"></i> Products
                          </Link>{" "}
                        </div>
                      </td>
                      <td
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          padding: "5px",
                        }}
                      >
                        <button
                          style={{
                            borderRadius: "5px",
                            margin: "5px",
                          }}
                          onClick={(e) => handleNoteUpdating(e, item)}
                          className="btn  btn-warning btn-with-icon"
                        >
                          <i class="fa fa-pen-to-square"></i>
                          {/* update */}
                        </button>
                        <button
                          style={{ borderRadius: "5px", margin: "5px" }}
                          onClick={(e) => handleDeleteDeliveryNote(e, item.ID)}
                          className="btn  btn-danger btn-with-icon"
                        >
                          <i class="fa-solid fa-trash-can"></i>
                          {/* Delete */}
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}
export default ListDeliveryNotes;
